import React from 'react';
import { ErrorBoundary } from '@fiverr-private/ui_utils';
import { logger } from '@fiverr-private/obs';
import { FederatedSeller, ProSubcategories, useSellerData } from '@fiverr-private/seller_pages_toolbox';
import { titleClass, itemClass } from './styles.ve.css';

const onRenderError = (originalError) => {
    const err = new Error('Failed while rendering the RolePageProSubcategories Component');
    logger.error(err, {
        cause: originalError,
    });
};

export const RolePageProSubcategories = () => {
    const { proSubCategories } = useSellerData(selectSellerSlice);

    if (!proSubCategories.length) {
        return null;
    }

    return (
        <ErrorBoundary onError={onRenderError}>
            <div>
                <ProSubcategories titleClassName={titleClass} itemClassName={itemClass} />
            </div>
        </ErrorBoundary>
    );
};

const selectSellerSlice = (seller: FederatedSeller) => ({
    proSubCategories: seller.proSubCategories,
});
